import React from 'react';
import PropTypes from 'prop-types';
import fetcher from 'lib/common/fetcher';
import panZoom from 'behaviours/panZoom'

const MiniMap = React.createClass({
    propTypes: {
        currentFacility: PropTypes.object,
        mainPanZoomInstance: PropTypes.object
    },
    getInitialState: function() {
        return {
            miniMapSvg: null
        }
    },
    updateThumbScope: function () {
        var mainPanZoomInstance = this.props.mainPanZoomInstance;
        var thumbnailPanZoomInstance = this.thumbnailPanZoomInstance;

        var scope = this._viewerScopeEl;
        var mainPanX = mainPanZoomInstance.getPan().x;
        var mainPanY = mainPanZoomInstance.getPan().y;
        var mainWidth = mainPanZoomInstance.getSizes().width;
        var mainHeight = mainPanZoomInstance.getSizes().height;
        var mainZoom = mainPanZoomInstance.getSizes().realZoom;
        var thumbPanX = thumbnailPanZoomInstance.getPan().x;
        var thumbPanY = thumbnailPanZoomInstance.getPan().y;
        var thumbZoom = thumbnailPanZoomInstance.getSizes().realZoom;

        var thumbByMainZoomRatio =  thumbZoom / mainZoom;

        var scopeX = thumbPanX - mainPanX * thumbByMainZoomRatio;
        var scopeY = thumbPanY - mainPanY * thumbByMainZoomRatio;
        var scopeWidth = mainWidth * thumbByMainZoomRatio;
        var scopeHeight = mainHeight * thumbByMainZoomRatio;

        if (scope) {
            scope.setAttribute('x', scopeX + 1);
            scope.setAttribute('y', scopeY + 1);
            scope.setAttribute('width', scopeWidth - 2);
            scope.setAttribute('height', scopeHeight - 2);
        }
    },
    updateMainViewPan: function(evt) {
        if (evt.which == 0 && evt.button == 0) {
            return false;
        }

        var mainPanZoomInstance = this.props.mainPanZoomInstance;
        var thumbnailPanZoomInstance = this.thumbnailPanZoomInstance;

        var dim = this._viewerEl.getBoundingClientRect();

        var mainSizes = mainPanZoomInstance.getSizes();
        var thumbSizes = thumbnailPanZoomInstance.getSizes();

        var mainZoom = mainSizes.realZoom;
        var thumbWidth  = thumbSizes.width;
        var thumbZoom =  thumbSizes.realZoom;

        var thumbPanX = evt.clientX - dim.left;
        var thumbPanY = evt.clientY - dim.top;

        var mainPanX = - thumbPanX * mainZoom / thumbZoom;
        var mainPanY = - thumbPanY * mainZoom / thumbZoom;
        var panXOffset = ((thumbWidth * 2) * mainZoom);

        mainPanZoomInstance.pan({
            x: mainPanX + panXOffset,
            y: mainPanY
        });
    },
    componentDidMount: function() {
        if (this.props.currentFacility && this.props.currentFacility.miniMapSvg) {
            fetcher.fetchHtml(this.props.currentFacility.miniMapSvg).then(miniMapSvg => {
                this.setState({
                    miniMapSvg: miniMapSvg
                });
            });
        }
    },
    componentDidUpdate: function() {
        if (this.state.miniMapSvg) {
            const mainPanZoomInstance = this.props.mainPanZoomInstance;

            const thumbnailSVG = this._thumbnailEl.querySelector('svg');
            this.thumbnailPanZoomInstance = panZoom(thumbnailSVG, {
                zoomEnabled: false,
                panEnabled: false,
                controlIconsEnabled: false,
                dblClickZoomEnabled: false,
                preventMouseEventsDefault: true
            });

            mainPanZoomInstance.setOnPan(this.updateThumbScope);
            this.updateThumbScope();

            this._viewerEl.addEventListener('click', this.updateMainViewPan);
            this._viewerEl.addEventListener('mousemove', this.updateMainViewPan);
        }
    },
    componentWillUnmount: function() {
        this._viewerEl.removeEventListener('click', this.updateMainViewPan);
        this._viewerEl.removeEventListener('mousemove', this.updateMainViewPan);
    },
    render: function () {
        /* eslint-disable react/no-danger */
        /* eslint-disable react/no-danger-with-children */
        return (this.state.miniMapSvg) ? (
            <div className="syos-minimap">
                <svg className="syos-minimap__viewer"
                    ref={el => this._viewerEl = el}>
                    <g>
                        <rect ref={el => this._viewerScopeEl = el}
                            fill="red" fillOpacity="0.1"
                            stroke="red" strokeWidth="2px"
                            x="0" y="0" width="0" height="0" />

                        <line id="line1"
                            stroke="red" strokeWidth="2px"
                            x1="0" y1="0" x2="0" y2="0" />

                        <line id="line2"
                            stroke="red" strokeWidth="2px"
                            x1="0" y1="0" x2="0" y2="0" />
                    </g>
                </svg>
                <div className="syos-minimap__thumbnail"
                    ref={el => this._thumbnailEl = el}
                    dangerouslySetInnerHTML={{
                        __html: this.state.miniMapSvg
                    }}>
                </div>
            </div>
        ) : null;
    }
});

export default MiniMap;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/MiniMap.js